<template>
  <div :class="wrapperClass">
    <div
      v-for="field in fields"
      :key="`${rowKeyPrefix}-${field.key}`"
      :class="fieldRowClass(field)"
    >
      <template v-if="field.labelOnly">
        <span :class="labelOnlyClass">{{ field.value }}</span>
      </template>
      <template v-else>
        <span :class="labelClass">{{ $t(field.labelKey) }}</span>
        <span
          :class="valueClass(field)"
          :draggable="isFieldDraggable(field)"
          @dragstart="onFieldDragStart($event, field)"
          @dragend="onFieldDragEnd"
        >
          <GenerationHistoryPromptPopover
            v-if="field.key === 'prompt' || field.key === 'concept' || field.key === 'category_shape'"
            :text="field.value"
            :tooltip="promptTooltip"
            :interactive="promptTooltip"
          />
          <template v-else>{{ field.value }}</template>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import GenerationHistoryPromptPopover from './GenerationHistoryPromptPopover.vue';

export default {
  name: 'GenerationHistoryMetaRows',
  components: {
    GenerationHistoryPromptPopover,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'detail'].includes(value),
    },
    rowKeyPrefix: {
      type: String,
      default: 'meta',
    },
    promptTooltip: {
      type: Boolean,
      default: false,
    },
    canDragFields: {
      type: Boolean,
      default: false,
    },
    dragFieldKeys: {
      type: Array,
      default: null,
    },
  },
  computed: {
    wrapperClass() {
      return this.variant === 'detail' ? 'gh-meta gh-meta--horizontal' : 'gh-inline-meta';
    },
    rowClass() {
      return this.variant === 'detail' ? 'gh-meta__row' : 'gh-inline-meta__row';
    },
    labelClass() {
      return this.variant === 'detail' ? 'gh-meta__label' : 'gh-inline-meta__label';
    },
    labelOnlyClass() {
      return this.variant === 'detail'
        ? 'gh-meta__schedule'
        : 'gh-inline-meta__schedule';
    },
  },
  methods: {
    fieldRowClass(field) {
      const classes = [this.rowClass];
      if (field && field.labelOnly) {
        classes.push(`${this.rowClass}--label-only`);
      }
      return classes;
    },
    valueClass(field) {
      const base = this.variant === 'detail' ? 'gh-meta__value' : 'gh-inline-meta__value';
      const classes = [base];
      if (field.key === 'prompt' || field.key === 'concept' || field.key === 'category_shape') {
        classes.push(`${base}--prompt`);
      }
      if (this.isFieldDraggable(field)) {
        classes.push('gh-dnd-source');
      }
      return classes;
    },
    isFieldDraggable(field) {
      if (!field || field.draggable === false || !this.canDragFields) {
        return false;
      }
      if (this.dragFieldKeys && this.dragFieldKeys.indexOf(field.key) === -1) {
        return false;
      }
      return !!(field.value && String(field.value).trim());
    },
    onFieldDragStart(event, field) {
      if (!this.isFieldDraggable(field)) {
        event.preventDefault();
        return;
      }
      this.$emit('field-drag-start', event, field);
    },
    onFieldDragEnd(event) {
      this.$emit('field-drag-end', event);
    },
  },
};
</script>
